import React from "react";
import { genres } from "../../musicPageData";

export default function GenreFilter({ activeGenre, onSelectGenre }) {
  return (
    <div className="genre-filter-bar">
      <div className="container">
        <div className="genre-filter-scroll">
          {genres.map((g) => (
            <button
              key={g}
              type="button"
              className={`genre-pill ${activeGenre === g ? "active" : ""}`}
              onClick={() => onSelectGenre(g)}
            >
              {g}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
